import { render, staticRenderFns } from "./UnitsBasic.vue?vue&type=template&id=c9c211ac&scoped=true&"
import script from "./UnitsBasic.vue?vue&type=script&lang=js&"
export * from "./UnitsBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c211ac",
  null
  
)

export default component.exports